import { ArenaMuralPost } from 'modules/arena/mural/types';

export const MURAL_FILTERS: { value: string; label: string }[] = [
  { value: 'all', label: 'Todos' },
  { value: 'racha', label: 'Rachas' },
  { value: 'aviso', label: 'Avisos' },
  { value: 'denunciado', label: 'Denunciados' },
  { value: 'removido', label: 'Removidos' },
];

// Os 3 primeiros posts são os mesmos que o jogador já vê em pages/Mural — esta é a
// visão de gestão da arena sobre o próprio feed. O post do Bruno T. é o mesmo caso
// já referenciado na fila de moderação do admin da plataforma (content/adminDashboardContent).
export const MOCK_ARENA_MURAL_POSTS: ArenaMuralPost[] = [
  {
    id: 'racha-marina',
    kind: 'racha',
    authorName: 'Marina L.',
    timeAgoLabel: 'há 12 min',
    text: 'Futevôlei hoje 19h, falta 1 pra fechar. Nível B/B+, R$ 25 por cabeça.',
    courtInfo: 'Areia 3 · 19:00',
    spotsLabel: '3/4',
    state: 'ativo',
    reportCount: 0,
  },
  {
    id: 'aviso-arena',
    kind: 'aviso',
    authorName: 'Arena Praia Norte',
    isOfficial: true,
    timeAgoLabel: 'há 2h',
    text: 'Areia 1 em manutenção sábado das 6h às 10h. As reservas do período foram remarcadas automaticamente e os valores já pagos estão garantidos no novo horário.',
    state: 'ativo',
    reportCount: 0,
  },
  {
    id: 'sem-quadra-diego',
    kind: 'sem-quadra',
    authorName: 'Diego C.',
    timeAgoLabel: 'ontem',
    text: 'Pickleball domingo de manhã? Se juntar 4, eu reservo a quadra e divido no app.',
    spotsLabel: '2/4 interessados',
    state: 'ativo',
    reportCount: 0,
  },
  {
    id: 'racha-bruno-denunciado',
    kind: 'racha',
    authorName: 'Bruno T.',
    timeAgoLabel: 'há 3h',
    text: 'Beach tennis 20h, só chama quem manja mesmo, não quero ninguém "turista" atrapalhando.',
    courtInfo: 'Areia 1 · 20:00',
    spotsLabel: '2/4',
    state: 'ativo',
    reportCount: 2,
  },
  {
    id: 'racha-spam-removido',
    kind: 'racha',
    authorName: 'Perfil suspeito',
    timeAgoLabel: '3 set',
    text: 'Confira promoções incríveis em nosso site! Link na bio.',
    state: 'removido',
    reportCount: 4,
  },
];
